var map = {
	"./animals_1.webp": 805,
	"./animals_10.webp": 7931,
	"./animals_11.webp": 2584,
	"./animals_12.webp": 7861,
	"./animals_2.webp": 6408,
	"./animals_3.webp": 9227
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1474;